import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import * as moment from 'moment';
import { criptoLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

class Vendas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vendas: [{}],
            expandedKeys: {},
            data_venda: [],
            valor_total: [],
            nome_produto: [],
            showDados: false
        };
    }

    componentDidMount() {
        const codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
        const cpf = decriptoLocalStorage('Codigo')?.decriptoValue;
        const token = localStorage.getItem('token');

        this.buscaDados(codigo, token, cpf);
    }

    url = retornoHashValor(process.env.REACT_APP_1);

    /*vendas no site*/
    buscaDados = (codigo, token, cpf) => {
        fetch(`${this.url  }/associados-vendas/${  codigo  }/${  cpf}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': token
            }
        })
            .then(response => response.json())
            .then(responseJson => {
                const label = [];
                const data_valor = [];
                const produto_ = [{ data: '',
                    produto: '',
                    valor: '' }];

                for (let i = 0; i < responseJson.length; i++) {
                    produto_[i] = { data: '',
                        produto: '',
                        valor: '' };
                    label[i] = responseJson[i]['ProdutosPreco.valorBase'];
                    data_valor[i] = moment(
                        responseJson[i]['Inscricaos.inscricao']
                    )
                        .add(3, 'hours')
                        .format('DD/MM/YYYY');
                    produto_[i]['produto'] =
                        responseJson[i]['Produto.descricao'];
                    produto_[i]['data'] = moment(
                        responseJson[i]['Inscricaos.inscricao']
                    )
                        .add(3, 'hours')
                        .format('DD/MM/YYYY');
                    produto_[i]['valor'] =
                        responseJson[i]['ProdutosPreco.valorBase'];
                }

                this.setState({
                    data_venda: data_valor,
                    valor_total: label,
                    vendas: produto_,
                    showDados: true
                });

                if (responseJson[0].Nome) {
                    criptoLocalStorage('Nome', responseJson[0].Nome);
                    criptoLocalStorage('Email', responseJson[0].Email);
                    criptoLocalStorage('Codigo', responseJson[0].CPF);
                    criptoLocalStorage('Link', responseJson[0].Link);
                }
            })
            .catch(err => err);
    };

    render() {
        const lineStylesData = {
            labels: this.state.data_venda,
            datasets: [
                /*{
                    label: 'Comissões',
                    data: this.state.valor_total,
                    fill: false,
                    borderColor: '#42A5F5'
                },*/
                {
                    label: 'Vendas',
                    data: this.state.valor_total,
                    fill: true,
                    borderColor: '#FFA726',
                    backgroundColor: '#FFCC80'
                }
            ]
        };

        return (
            <div>
                <Panel header="Ultimas Vendas" className="showDados">
                    {this.state.showDados ? (
                        <DataTable value={this.state.vendas}>
                            <Column field="data" header="Data" />
                            <Column field="produto" header="Produto" />
                            <Column field="valor" header="Valor" />
                        </DataTable>
                    ) : (
                        <p>Nenhuma venda atual</p>
                    )}
                </Panel>
                <br />
                <Panel header="Vendas">
                    <div className="content-section introduction">
                        <div className="feature-intro"></div>
                    </div>

                    <div className="content-section implementation">
                        <h3>Line Styles</h3>
                        <Chart type="line" data={lineStylesData} />
                    </div>
                </Panel>
            </div>
        );
    }
}

export default Vendas;
